import { Component } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ProjectEntityListActions } from '../../store/project-entity-list/project-entity-list.actions';
import { pageSizeOptions } from '../../store/project-entity-list/project-entity-list.state';
import { selectCount, selectPage, selectPageSize } from '../../store/project-entity-list/project-entity-list.selectors';

@Component({
  selector: 'app-project-list-paging',
  templateUrl: './project-list-paging.component.html',
  styleUrls: ['./project-list-paging.component.scss'],
  standalone: false
})
export class ProjectListPagingComponent {
  page$: Observable<number>;
  pageSize$: Observable<number>;
  count$: Observable<number>;
  pageSizeOptions = pageSizeOptions;

  constructor(private store: Store) {
    this.page$ = this.store.select(selectPage);
    this.pageSize$ = this.store.select(selectPageSize);
    this.count$ = this.store.select(selectCount);
  }

  handlePageEvent(event: PageEvent) {
    this.store.dispatch(ProjectEntityListActions.change_paging({ page: event.pageIndex, pageSize: event.pageSize }));
  }
}
